import { Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import { InputType } from "../../../models";
import {
  checkEmptyObject,
  formatNumber,
  parseFormControlValue
} from "../../../services";
import { getIconUrl } from "../../../services/asset";
import { InputText } from "../InputText";
import styles from "../Money/styles.scss";

const Power = {
  main: "kW",
  alternative: "kS"
};

const revertCurrency = currency =>
  currency === Power.main ? Power.alternative : Power.main;

const getCurrencyUnit = currency =>
  currency === Power.main ? Power.main : Power.alternative;

// 1 kW = 1.35962 horse power
const CONVERT_POWER_VALUE = 1.359;

const HorsePower = props => {
  const {
    currencyField,
    defaultCurrency,
    defaultValue,
    field,
    isRequired,
    title,
    value
  } = props;

  const newValue = checkEmptyObject(value) ? value[field] : defaultValue;
  const currency = (value && value[currencyField]) || defaultCurrency;

  const calculateLeftValue = (value, currency) => {
    let result =
      currency === Power.main ? value * CONVERT_POWER_VALUE : value / CONVERT_POWER_VALUE;

    return value ? Math.round(result) : 0;
  };

  const [state, setState] = useState({
    value: {
      [field]: formatNumber(newValue)
    },
    leftValue: {
      [field]: calculateLeftValue(newValue, currency)
    },
    currency
  });



  const handleValueChange = value => {
    const { field, onChange, currencyField } = props;
    const { currency } = state;

    const values = {
      value,
      leftValue: {
        [field]: !value ? 0 : calculateLeftValue(value[field], currency)
      },
      currency
    };

    setState(values);

    onChange(
      currency == Power.main
        ? parseFormControlValue(
          [field, currencyField],
          [(value && value[field]) || 0, currency]
        )
        : parseFormControlValue(
          [field, currencyField],
          [(values && values["leftValue"][field]) || 0, currency]
        )
    );
  };

  const currencyUnit = getCurrencyUnit(currency);
  const revertedCurrencyUnit = getCurrencyUnit(revertCurrency(currency));

  return (
    <React.Fragment>
      <span className={`control-title ${isRequired ? "required" : ""}`}>
        {title}
      </span>
      <Row>
        <Col xs={10} sm={10} md={10} lg={10} xl={10} xxl={11}>
          <InputText
            unit={currencyUnit}
            valueType={InputType.int}
            field={field}
            value={state.value}
            defaultValue={defaultValue}
            onChange={handleValueChange}
            inputTypeNumber={true}
          />
        </Col>
        <Col
          xs={4}
          sm={4}
          md={4}
          lg={4}
          xl={4}
          xxl={2}
          className={styles.exchangeIconContainer}
        >
          <div tabIndex={0}>
            <img
              className={styles.icon}
              alt="convert icon"
              src={getIconUrl("equal.svg")}
            />
          </div>
        </Col>
        <Col xs={10} sm={10} md={10} lg={10} xl={10} xxl={11}>
          <InputText
            unit={revertedCurrencyUnit}
            valueType={InputType.int}
            field={field}
            value={state.leftValue}
            defaultValue={calculateLeftValue(defaultValue, defaultCurrency)}
            isDisabled
            placeholder=""
          />
        </Col>
      </Row>
    </React.Fragment>
  );
};

HorsePower.defaultProps = {
  title: "",
  isRequired: false,
  onChange: () => null,
  defaultValue: 0
};

export default React.memo(HorsePower);



// WEBPACK FOOTER //
// ./src/components/FormControls/HorsePowerInput/HorsePower.tsx